import { render, staticRenderFns } from "./Progress.vue?vue&type=template&id=35ed5335&lang=pug&"
var script = {}
import style0 from "./Progress.vue?vue&type=style&index=0&id=35ed5335&prod&module=true&lang=sass&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports